<template>
  <CHeader fixed with-subheader light>

    <CHeaderBrand class="mx-auto d-lg-none" to="/">
      <CIcon name="logo" height="48" alt="Logo"/>
    </CHeaderBrand>
    <CHeaderNav class="d-md-down-none mr-auto">
      <form class="navbar-search navbar-search-dark text-black-50 form-inline ml-3 d-md-flex ">
            <div class="form-group mb-0">
                <a-input placeholder="Vyhľadávanie"
                            class="input-group-alternative search-small"
                            alternative=""
                            v-model="searchQuery"
                            @change="findItAll"
                            addon-right-icon="fad fa-search">
                </a-input>
                <div class="searchoutput" v-if="searchResults.length > 0">
                    <a-list size="small" bordered :data-source="searchResults">
                      <a-list-item slot="renderItem" slot-scope="item" class="p-0">
                      <template v-if="item.ctt == 'product'">
                      <router-link v-if="item.bundle === 'node'" :to="'/edit-content/' + item.entity_id"  :class="'w-100 p-2 bundle-' + item.bundle + (item.parent != '0' ? ' child' : '')"  :href="'/edit-content/' + item.entity_id">
                      <a-row>
                        <a-col :span="1" v-if="item.parent != '0'"><span class="child-marker">-</span></a-col>
                        <a-col :span="2" v-if="item.image" class="text-center item-image"><template v-if="item.image"><img :src="item.image"></template></a-col>
                        <a-col :span="21"><div class="title">{{ item.value }}</div>  <span class="pill" v-if="item.attr">{{ item.attr }}</span> <span class="pill" v-if="item.cttt"> <template v-if="item.attr">| </template>{{ item.cttt }}</span>
                        <span class="pill" v-if="item.extid"> | {{ item.extid }}</span></a-col>
                      </a-row>
                      </router-link>
                      </template>
                      <template v-else>
                      <router-link v-if="item.bundle === 'node'" :to="'/edit-content/' + item.entity_id"  :class="'p-2 w-100 bundle-' + item.bundle"  :href="'/edit-content/' + item.entity_id">
                      <a-row>
                        <a-col :span="2" v-if="item.image" class="text-center item-image"><template v-if="item.image"><img :src="item.image"></template></a-col>
                        <a-col :span="22"><div class="title">{{ item.value }}</div> <span class="pill" v-if="item.cttt">{{ item.cttt }}</span></a-col>
                      </a-row>

                      </router-link>
                      </template>
                      <router-link v-if="item.bundle === 'taxonomy'" :to="'/edit-taxonomy-item/' + item.entity_id + '/' + item.content_type"  :class="'p-2 w-100 bundle-' + item.bundle"  :href="'/edit-taxonomy-item/' + item.entity_id + '/' + item.content_type">

                      <a-row>
                        <a-col :span="2" v-if="item.image" class="text-center item-image"><template v-if="item.image"><img :src="item.image"></template></a-col>
                        <a-col :span="22"><div class="title">{{ item.value }}</div> <span class="pill" v-if="item.voc">{{ item.voc }}</span></a-col>
                      </a-row> </router-link>
                      </a-list-item>
                    </a-list>
                </div>
            </div>
        </form>
    </CHeaderNav>
      <CHeaderNav class="ms-auto">
        <CNavItem>

<template v-if="messages.length == 0">
  <CButton variant="ghost" class="position-relative">
            <CIcon name="cil-bell" size="lg"></CIcon>
     </CButton>
</template>
<template v-else>
          <CDropdown inNav class="c-header-nav-items" placement="bottom-end" add-menu-classes="pt-0">
    <template #toggler>
        <CButton variant="ghost" class="position-relative">
            <CIcon name="cil-bell" size="lg"></CIcon>
             <CBadge color="danger" position="top-end" v-if="messages.length > 0" style="position:absolute" shape="rounded-pill">{{messages.length}}</CBadge>
         </CButton>
    </template>
     <template v-if="messages.length > 0">
          <template v-for="message in messages">
            <CDropdownItem :key="'msg-' + message.id">
              <router-link :to="message.link"  class="list-group-item list-group-item-action">
                  <div class="row align-items-center">
                      <div class="col-auto">
                      <i :class="(message.new ? 'fas' : 'far')  + ' fa-bell'"></i>
                      </div>
                      <div class="col ml--2">
                          <div class="d-flex justify-content-between align-items-center">
                                <div class="text-right text-muted">
                                  <small>{{moment(message.created).format('DD.MM.YYYY HH:mm')}}</small>
                              </div>
                          </div>
                            <p class="text-sm mb-0">{{message.message}}</p>
                      </div>
                  </div>
              </router-link>
            </CDropdownItem>
          </template>

      </template>
  </CDropdown></template>
       </CNavItem>
      </CHeaderNav>
    <CHeaderNav class="mr-4">
      <TheHeaderDropdownAccnt :user="user"/>
    </CHeaderNav>
  </CHeader>
</template>

<script>
import TheHeaderDropdownAccnt from './TheHeaderDropdownAccnt'
import { CHeaderNav,  CBadge } from '@coreui/vue'
import Vue from "vue";
 import {Menu} from 'ant-design-vue';
    import {dataService} from "../_services";
    import {List} from 'ant-design-vue';

    Vue.use(Menu);
export default {
  name: 'TheHeader',
  components: {
    TheHeaderDropdownAccnt,
    CHeaderNav,
    CBadge,
    "a-list": List
  },
  data() {
            return {
                sidebarBackground: 'vue',
                contenttypes: [],
                taxonomies: [],
                searchQuery: '',
                collapsed: false,
                unitType: "",
                 messages: [],
                newmessages:0,
                openKeys: [],
                fieldData: {},
                user:{},
                searchResults:[],
                loggedIn: localStorage.getItem('user'),
                roles: [],
                paths: [],
                ctypes: [],
                selectedKeys: []
            };
        },
     mounted() {
      this.user = JSON.parse(this.loggedIn);
            this.selectedKeys = [this.$router.currentRoute.name];
            const loggedIn = localStorage.getItem('user');
            const user = JSON.parse(loggedIn);
            this.roles = user.data.type_id;
            this.paths = user.data.paths;
            this.unitType = user.data.unitType;
            this.ctypes = user.data.ctypes;
               this.fetch();
        },
          methods: {
            toggleSidebar() {
                if (this.$sidebar.showSidebar) {
                    this.$sidebar.displaySidebar(false);
                }
            },
               seen()
            {
                setTimeout(() => {
dataService.axiosPost("read",{message: this.messages[0].id}).then(() => {
this.fetch();
                });
            }, 400);

            },

              stateCheck() {
              dataService.axiosFetch("state/messages").then(results => {
                    this.lastState = results[0].l;
                });
            },
            findItAll(ef)
            {

var e = ef.target.value;
              if(e.length > 2)
            {dataService.axiosPost('findnodes', {searchterm: e}).then(results => {

              this.searchResults = results.data.data;
            });
            }
              else
              {this.searchResults = [];}

              },
                  fetch() {
      dataService.axiosFetch("notifications").then(results => {
        this.messages = results.messages;
        this.newmessages = results.new;

        if (this.newmessages > 0) {
          let delay = 0;
          this.messages.forEach((element) => {
            if (element.new && !this.displayedNotificationIds.has(element.id)) {
              setTimeout(() => {
                this.openNotification('bottomRight', element.message, element.link, element.id);
                this.displayedNotificationIds.add(element.id); // Mark the notification as displayed
              }, delay);
              delay += 500; // Adjust delay as needed (500ms between each notification)
            }
          });
        }
      });
    },
        },
        watch:{
            // eslint-disable-next-line no-unused-vars
            lastState: function(val) {
                //do something when the data changes.
                if (val) {
                     this.fetch();

                }
            }
        },
}
</script>
<style>
.navbar-search .searchoutput
{display:none;
      position: absolute;
    top: 44px;
    z-index: 9999;
    max-height: 60vh;
    background-color: #fff;
    min-width: 249px;
    overflow-y: auto;
    left: 31px;
}
    .searchoutput .bundle-node.child
    {
      padding-left:28px!important;
    }

.searchoutput .ant-list-item:hover
{background-color:#f8f9fa !important;}
    .navbar-search:hover .searchoutput
    {
      display:block;
    }
.child-marker
{font-size:22px;font-weight:bold;color:rgba(0, 0, 0, 0.65);}
    .pill
    {color:rgba(0, 0, 0, 0.65);
    font-size:12px;
    }
    .searchoutput .item-image
    {overflow:hidden}
    .searchoutput .item-image img
    {max-width:100%;display:block;}
</style>
